/**
 * Petite indirection de redirection, pour que Cypress puisse observer où l'on part.
 *
 * L'instance `Location` de Chromium est non configurable — `assign`, `replace` et `href` ne peuvent
 * pas être remplacés depuis JavaScript — et laisser le navigateur exécuter la navigation
 * cross-origin casse les specs suivantes depuis Cypress 14. Passer par un crochet posé sur `window`
 * permet de capturer la cible sans jamais quitter localhost. En production, aucun crochet n'existe et
 * l'appel retombe sur `window.location.assign`.
 *
 * Extrait de `login.page.ts` pour être partagé avec la route de rappel du portail : deux indirections
 * de redirection, ce serait une de trop, et Cypress n'en observerait qu'une.
 */
const RM_REDIRECT_HOOK_KEY = '__rmRedirect';

type RedirectFn = (url: string) => void;

export function rmRedirect(url: string): void {
  const hook = (window as unknown as Record<string, RedirectFn | undefined>)[
    RM_REDIRECT_HOOK_KEY
  ];
  if (hook) {
    hook(url);
  } else {
    window.location.assign(url);
  }
}
